export default __webpack_public_path__ + "static/media/Strangler's Boots of Malice.d441fa9a.jpg";